<template>
  <div id="price" class="p-4 bg-beige border-t border-section_border">
    <div class="p-4 bg-white rounded-lg">
      <h3 class="section-title mb-4 text-lg text-center">{{ $t('tour_normal_fare') }}</h3>
      <div id="total" class="flex justify-between items-end flex-wrap mb-8 px-1 pb-1 border-b border-section_border">
        <p>{{ $t('tour_fare') }}</p>
        <p v-html="$t('tour_price_with_currency_unit', { price: totalPrice.toLocaleString() })"></p>
      </div>
      <ul>
        <li v-for="pass in totalFreePass" :key="pass.name" class="mb-8">
          <div v-if="pass.available === 'true'">
            <h3 class="section-title mt-2 mb-4 text-lg font-semibold text-center">{{ pass.name }}</h3>
            <!--
            <div class="flex justify-between items-end flex-wrap mb-4 pb-1 border-b border-section_border">
              <div>
                <P>{{ pass.name }}</P>
                <P class="text-supplement text-sm"></P>
              </div>
              <p v-html="$t('tour_price_with_currency_unit', { price: pass.freePassPrice.toLocaleString() })"></p>
            </div>
            <div class="flex justify-between items-end flex-wrap mb-4 pb-1 border-b border-section_border">
              <p>{{ $t('tour_other_fare') }}</p>
              <p v-html="$t('tour_price_with_currency_unit', { price: pass.otherPrice.toLocaleString() })"></p>
            </div>
            <p class="mb-2 text-right text-red">{{ discountPriceText(pass.freePassPrice + pass.otherPrice) }}</p>
            -->
            <p class="text-right text-link">
              <a :href="pass.ticketLink" class="flex justify-end items-center">
                <span>{{ $t('tour_freepass_link') }}</span>
                <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="m10 3.20710678v6.29289322c0 .27614237-.22385763.5-.5.5h-6.29289322c-.27614237 0-.5-.22385763-.5-.5 0-.13260824.05267842-.2597852.14644661-.35355339l6.29289322-6.29289322c.19526215-.19526215.51184463-.19526215.70710678 0 .09376819.09376819.14644661.22094515.14644661.35355339z" fill-rule="evenodd" transform="matrix(.70710678 -.70710678 .70710678 .70710678 -.485281 10)"/></svg>
              </a>
            </p>
          </div>
        </li>
      </ul>
    </div>
    <p v-if="getTotalFareAndCharge['totalCharge'] > 0" class="mt-2 text-sm text-right">
      {{ $t('tour_total_charge_description') }}
    </p>
    <p v-if="getUseTaxi" class="mt-2 text-sm text-right">
      {{ $t('tour_get_use_taxi_description') }}
    </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Constants from '../../constants'

export default {
  computed: {
    ...mapGetters({
      getUseTaxi: 'routes/getUseTaxi',
      getTotalFreePass: 'routes/getTotalFreePass',
      getTotalFareAndCharge: 'routes/getTotalFareAndCharge'
    }),
    totalPrice: function () {
      var totalSet = this.getTotalFareAndCharge
      return (totalSet['totalFare'] + totalSet ['totalCharge'])
    },
    totalFreePass: function () {
      var result = {}
      var list = this.getTotalFreePass
      for (let key in list) {
        if (list[key]['freePassPrice'] > 0) result[key] = list[key]
      }
      return result
    }
  },
  methods: {
    discountPriceText: function (price) {
      var diff = this.totalPrice - price
      if (diff > 0) {
        return this.$t('tour_freepass_merit', { price: diff.toLocaleString() })
      } else {
        return null
      }
    },
    freepass_url: function (type) {
      var env_key = process.env.VUE_APP_LINK_BASE_ENV || process.env.NODE_ENV
      return Constants.LINK_BASE_URL_LIST[env_key] + Constants.FREEPASS_URL_LIST[type]
    }
  }
}
</script>
